import Vue from "vue";

export const format = {
  data() {
    return {}
  },
  methods: {
    formatAmount(amount = 0) {
     return Math.round(this.formatToDollars(amount)).toLocaleString()
    },
    formatToCents(amount) {
      return Math.round(amount * 100);
    },
    formatToDollars(amount) {
      return amount / 100
    },
    getCurrencySign(currency) {
      if (!currency || typeof currency !== "string") return  '';

      currency = currency.toUpperCase();

      switch (currency) {
        case 'USD': {
          return '$';
        }
        case 'EUR': {
          return '€';
        }
        case 'GBP': {
          return '£';
        }
        case 'JPY': {
          return '¥';
        }
        case 'AUD': {
          return 'AU$';
        }
        case 'CAD': {
          return 'CA$';
        }
        case 'CHF': {
          return 'CHF';
        }
        case 'CNY': {
          return '¥';
        }
        case 'SEK': {
          return 'kr';
        }
        case 'MXN': {
          return 'Mex$';
        }
        case 'NZD': {
          return 'NZ$';
        }
        case 'SGD': {
          return 'S$';
        }
        case 'HKD': {
          return 'HK$';
        }
        case 'NOK': {
          return 'kr';
        }
        case 'KRW': {
          return '₩';
        }
        case 'TRY': {
          return '₺';
        }
        case 'INR': {
          return '₹';
        }
        case 'RUB': {
          return '₽';
        }
        case 'BRL': {
          return 'R$';
        }
        case 'ZAR': {
          return 'R';
        }
        case 'DKK': {
          return 'kr';
        }
        case 'PLN': {
          return 'zł';
        }
        default:
          return currency;
      }
    },
    floatToPercent(percent) {
      return parseInt(percent * 100);
    },
    floatDecimalNormalize(number, decimals = 2) {
      return parseFloat(number.toFixed(decimals));
    },
    copyText(id) {
      const input = document.getElementById(id);
      input.select();
      document.execCommand("copy");
    },
    formatValue(value, field) {
      if (value !== null && value !== undefined) {
        if (_.isObject(value)) {
          if (value instanceof Date) {
            return this.formatDate(value, 'L');
          } else if (value.hasOwnProperty('value')) {
            return value.value;

          } else if (Array.isArray(value) && (!field || field.assembleValues === true || field.assembleValues === undefined)) {
            return value.map(item => item.value);
          } else {
            return value;
          }
        } else {
          return value
        }
      } else {
        return null
      }
    },
    createObject(obj) {
      if (!obj) {
        obj = {}
      }
      return obj
    },
    getValueOf(value) {
      if (value === null)
        return null
      return value.value ? value.value : value
    },
    formatOption(value, key = 'name') {
      if (value !== null && value !== undefined) {
        if (typeof value === 'object') { return value }
        return {
          [key]: value.toString().charAt(0).toUpperCase() + value.toString().slice(1),
          value: value
        }
      }
    },
    isEven(index) {
      return index % 2 === 0;
    },
    deserializeObject(obj, keys, label) {
      return new Promise((resolve, reject) => {
        let objMutated = {};
        _.mapKeys(obj, (value, key) => {
          if (keys.indexOf(key) !== -1) {
            if (key === 'terms') {
              objMutated[key] = [];
              obj[key].map(item => {
                if (item.title) {
                  objMutated[key].push({
                    label: item.title,
                    value: item.title,
                    id: item.id,
                    key: item.key
                  })
                } else {
                  objMutated[key].push({
                    label: item.key,
                    value: item.key,
                    id: item.id,
                    key: item.key
                  })
                }
              })
            } else if (Array.isArray(obj[key])) {
              obj[key].map(item => {
                objMutated[key] = [];
                objMutated[key].push(this.formatOption(item.title, label))
              })
            } else {
              objMutated[key] = this.formatOption(value, label)
            }
          } else {
            objMutated[key] = value
          }
        });
        resolve(objMutated)
      });
    },
    serializeObject(obj, keys) {
      return new Promise((resolve, reject) => {
        let objMutated = {};
        if (Array.isArray(obj)) {
          obj.map(item => {
            _.mapKeys(item, (value, key) => {
              if (keys.indexOf(key) !== -1) {
                objMutated[key] = this.formatValue(value)
              } else {
                objMutated[key] = value
              }
            })
          })
        } else {
          _.mapKeys(obj, (value, key) => {
            if (keys.indexOf(key) !== -1) {
              objMutated[key] = this.formatValue(value)
            } else {
              objMutated[key] = value
            }
          })
        }
        resolve(objMutated)
      })
    },
    addReactiveItemToArray(array, item) {
      if (!array) {
        array = []
      }
      this.$set(array, array.length, item);
      this.$forceUpdate()
    },
    deleteItemByIndex(array, index) {
      this.$delete(array, index);
      this.$forceUpdate()
    },
    slugify(string) {
      const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
      const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
      const p = new RegExp(a.split('').join('|'), 'g');

      return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
    },
    maskIPGeneralFormat(input, startCursorPosition, onlyIp = false) {
      let result = input;
      let cursorPosition = startCursorPosition;
      const digitRegexp = /[\d]/;

      const maskFormat = onlyIp ? '_._._._' : '_._._._/_';

      if (!digitRegexp.test(result)) {
        return {result: maskFormat, cursorPosition: 0}
      }

      const invalidCharRegexp = /[^0-9./]/g;
      if (invalidCharRegexp.test(result)) {
        result = result.replace(invalidCharRegexp, '');
        if (result === '') {
          return {result: maskFormat, cursorPosition: 0}
        }
      }

      let octetsStr = '';
      let subnetMask = '';
      let subnetMaskArr = result.split('/');

      if (subnetMaskArr.length > 1) {
        subnetMask = subnetMaskArr[subnetMaskArr.length - 1]
        for (let i = 0; i < subnetMaskArr.length - 1; i++) {
          octetsStr = octetsStr + subnetMaskArr[i];
        }
      } else {
        octetsStr = result;
      }
      let octetsArr = octetsStr.split('.');
      if (octetsArr.length > 4) {
        for (let i = 4; i < octetsArr.length - 1; i++) {
          octetsArr[3] = octetsArr[3] + octetsArr[i];
        }
        octetsArr = octetsArr.slice(0, 4);
      }
      if (!digitRegexp.test(subnetMask)) {
        subnetMask = '';
      }
      for (let i = 0; i < 4; i++) {
        if (!digitRegexp.test(octetsArr[i])) {
          octetsArr[i] = ''
        }
      }

      let octetOverflow = false;
      let oneSignOverflow = false;
      for (let i = 0; i < 4; i++) {
        if (octetsArr[i].length > 3) {
          octetOverflow = true;
          if (octetsArr[i].length === 4 && !oneSignOverflow) {
            let len = i;
            for (let j = 0; j <= i; j++) {
              len += octetsArr[j].length;
            }
            oneSignOverflow = true;
            if (cursorPosition === len) {
              cursorPosition += 1;
            }
          }
          if (i < 3) {
            octetsArr[i + 1] = octetsArr[i].slice(3) + octetsArr[i + 1];
            octetsArr[i] = octetsArr[i].slice(0, 3)
            continue
          }
          subnetMask = octetsArr[i].slice(3) + '';
          octetsArr[i] =  octetsArr[i].slice(0, 3);
        } else if (!octetsArr[i].length) {
          octetsArr[i] = '_';
        }
      }
      if (subnetMask.length > 2) {
        subnetMask =  subnetMask.slice(0, 2);
      } else if (subnetMask === '') {
        subnetMask = '_';
      }
      if (onlyIp) {
        result = octetsArr.join('.')
      } else {
        result = octetsArr.join('.') + '/' + subnetMask
      }
      if (!oneSignOverflow && octetOverflow) {
        cursorPosition = result.length;
      }

      return {result: result, cursorPosition: cursorPosition};
    },
    IPFormatter(value, event) {
      let input = value;

      // Remove any characters that are not digits or dots
      input = input.replace(/[^0-9.]/g, '');

      // Remove extra dots
      input = input.split('.').map(section => section.slice(0, 3)).join('.');

      // Auto-insert dots after every 3 digits
      if (input.length >= 3 && input[3] !== '.') input = input.slice(0, 3) + '.' + input.slice(3);
      if (input.length >= 7 && input[7] !== '.') input = input.slice(0, 7) + '.' + input.slice(7);
      if (input.length >= 11 && input[11] !== '.') input = input.slice(0, 11) + '.' + input.slice(11);

      return input;
    },
    maskIPFormatter(input, event, onlyIp = false) {
      let target = event.target;
      let cursorPosition = target.selectionStart;
      let data = event.data;
      let result = input;
      const inputFormat = onlyIp ? '_._._._' : '_._._._/_';
      if (event.type === 'blur' && (input === inputFormat || input === '')) {
        return ''
      }
      const invalidChar = /[^0-9./_ ]/;

      let deletedSeparators = [
        /^(\d{1,3}|_)(\d{1,3}|_)\.(\d{1,3}|_)\.(\d{1,3}|_)\/(\d{1,2}|_)$/,
        /^(\d{1,3}|_)\.(\d{1,3}|_)(\d{1,3}|_)\.(\d{1,3}|_)\/(\d{1,2}|_)$/,
        /^(\d{1,3}|_)\.(\d{1,3}|_)\.(\d{1,3}|_)(\d{1,3}|_)\/(\d{1,2}|_)$/,
        /^(\d{1,3}|_)\.(\d{1,3}|_)\.(\d{1,3}|_)\.(\d{1,3}|_)(\d{1,2}|_)$/,
      ]
      for (let i = 0; i < 4; i++) {
        if (deletedSeparators[i].test(input)) {
          if (i < 3) {
            result = result.slice(0, cursorPosition) + '.' + result.slice(cursorPosition);
          } else if (!onlyIp) {
            result = result.slice(0, cursorPosition) + '/' + result.slice(cursorPosition);
          }

          this.saveCursorPosition(target, cursorPosition);
          return result;
        }
      }

      if (data) {
        if (data.match(invalidChar)) {
          result = result.replace(invalidChar, '');
          cursorPosition -= 1;
        } else if (data === '.' || data === '/') {
          result = result.slice(0, cursorPosition-1) + result.slice(cursorPosition);
          cursorPosition = cursorPosition + result.slice(cursorPosition-1).search(new RegExp("\\" + data));
        } else if (data === '_' || data === ' ') {
          result = result.slice(0, cursorPosition-1) + result.slice(cursorPosition);
          if (result[cursorPosition-1] !== '_') {
            cursorPosition -= 1;
          }
        } else {
          if (result[cursorPosition] === '_') {
            result = result.slice(0, cursorPosition) + result.slice(cursorPosition+1);
          } else if (result[cursorPosition-2] === '_') {
            result = result.slice(0, cursorPosition-2) + result.slice(cursorPosition-1);
            cursorPosition -= 1;
          } else {
            let generalFormatObj = this.maskIPGeneralFormat(result, cursorPosition, onlyIp);
            result = generalFormatObj.result;
            cursorPosition = generalFormatObj.cursorPosition
          }
        }
      } else {
        let generalFormatObj = this.maskIPGeneralFormat(result, cursorPosition, onlyIp);
        result = generalFormatObj.result;
        cursorPosition = generalFormatObj.cursorPosition
      }

      this.saveCursorPosition(target, cursorPosition);
      return result;
    },
    saveCursorPosition(target, position) {
      Vue.nextTick(function () {
        Vue.nextTick(function () {
          target.setSelectionRange(position, position);
        })
      })
    }
  }
};
